import { IMfaSessionRow, TMfaSessionsResult } from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import {
	buildMobileLabels,
	transformLabels
} from 'src/apps/mobile-common/helpers/MobileLabelsHelper';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import { ILabelConfig } from 'src/common/types/LabelsTypes';

import { MfaSessionsQuery } from '../MfaSessions.generated';

export const transformMfaSessionsResults = (
	rawResults: MfaSessionsQuery,
	labelsConfig?: ILabelConfig[]
): TMfaSessionsResult => {
	const rows: IMfaSessionRow[] =
		rawResults.mfa_session_runs?.filter(returnNonNull).map((session) => {
			const allLabels = transformLabels(
				session.custom_fields,
				buildMobileLabels(session),
				labelsConfig
			);

			return {
				sessionId: session.run_id,
				sessionName: session.session_name,
				totalScans: session.total_scans,
				totalIssues: session.total_issues,
				criticalIssues: session.critical_issues,
				seriousIssues: session.serious_issues,
				moderateIssues: session.moderate_issues,
				minorIssues: session.minor_issues,
				bestPracticeIssues: session.best_practice_issues,
				needsReviewIssues: session.needs_review_issues,
				lastModified: session.run_updated_at,
				owner: session.user_name,
				labels: allLabels,
				platform: session.os,
				appName: session.app,
				appVersion: session.app_version
			};
		}) ?? [];

	const total = rawResults.total?.[0]?.run_id_count ?? 0;
	const unfilteredTotal = rawResults.unfiltered_total?.[0]?.run_id_count ?? 0;

	return {
		rows,
		total,
		unfilteredTotal
	};
};
